import { c as _c } from "react/compiler-runtime";
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
import type { AdvancedMentoringProductDTO } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { MENTOR_REPLY_TIME } from '@/common/enums';
import { H4 } from '@/frontend/design-system/_marketing/typography/Heading/H4';
import { Button } from '@/frontend/design-system/actions/Button';
type MentorReplyTimeProps = {
  advancedMentoringProduct: AdvancedMentoringProductDTO;
  updateProduct: (updates: Partial<AdvancedMentoringProductDTO>) => void;
};
export function MentorReplyTime(t0) {
  const $ = _c(5);
  const {
    advancedMentoringProduct,
    updateProduct
  } = t0;
  const mentorReplyTime = advancedMentoringProduct.mentorReplyTime;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H4>Czas oczekiwania na odpowiedź mentora</H4>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Object.values(MENTOR_REPLY_TIME);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== mentorReplyTime || $[3] !== updateProduct) {
    t3 = <IconOnTheLeftWithContentLayout mainContent={t1}><div className="flex flex-row flex-wrap gap-2">{t2.map(option => <Button key={option} className="w-fit border-transparent text-sm" onClick={() => updateProduct({
          mentorReplyTime: option
        })} marketing={true} marketingVariant={mentorReplyTime === option ? "primary" : "neutral"} rounded={true}>{option === MENTOR_REPLY_TIME.STANDARD ? `${option} (standard)` : option}</Button>)}</div></IconOnTheLeftWithContentLayout>;
    $[2] = mentorReplyTime;
    $[3] = updateProduct;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}